import { ActionStatus } from '../../constants/api';
import CreateAction from '../../utils/actions';

export interface PreCheckUserPayload {
	user_name: string;
	state: string;
	scope: Array<string>;
	nonce: string;
	redirect_url: string;
	response_type: string;
	token?: string;
}

export interface LoginUserPayload {
	password: string;
	nonce: string;
}
export interface ValidateOtpPayload {
	otp: string;
	nonce: string;
}

export interface ResendOtpPayload {
	nonce: string;
}

export interface PinPayload {
	nonce: string;
	pin: string;
	method: string;
}
export interface TNCPayload {
	nonce: string;
	action: string;
}

export const SetCaptchaToken = CreateAction<string>('SetCaptchaToken');
export const SetUserNameText = CreateAction<string>('SetUserNameText');
export const SetPasswordText = CreateAction<string>('SetPasswordText');
export const SetOtpText = CreateAction<string>('SetOtpText');
export const BackPreCheck = CreateAction('BackPreCheck');
export const PreCheckUser = CreateAction<PreCheckUserPayload>('PreCheckUserName');
export const LoginUser = CreateAction<LoginUserPayload>('LoginUser');
export const ValidateOtp = CreateAction<ValidateOtpPayload>('ValidateOtp');
export const SetupPin = CreateAction<PinPayload>('SetupPin');
export const AcceptTNC = CreateAction<TNCPayload>('AcceptTNC');
export const NavigateCode = CreateAction<ResendOtpPayload>('NavigateCode');
export const ResendOTP = CreateAction<ResendOtpPayload>('ResendOTP');
export const ChangeNextView = CreateAction<string>('ChangeNextView');
export const ResetForm = CreateAction<string>('ResetForm');
export const ValidateEmail = CreateAction<any>('ValidateEmail');
export const ResetTimer = CreateAction<any>('ResetTimer');

export interface LoginState {
	captchaToken: string;
	nextView: string;
	currentNonce: string;
	userNameText: string;
	passwordText: string;
	preCheckStatus: ActionStatus;
	loginStatus: ActionStatus;

	otp: string;
	otpStatus: ActionStatus;
	resndOtpStatus: ActionStatus;
	otpError: string;

	pinStatus: ActionStatus;
	pinError: string;

	codeStatus: ActionStatus;
	codeError: string;

	location: string;

	display_message: string;
	action_message: string;
	action_time: number;

	tncStatus: ActionStatus;
	tncError: string;
	tncUpdated: boolean;
	tncContent: string;
	tncSkipCount: number;
}
